"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RangeCalendar = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _styles = require("./styles");

var _react = require("react");

var _reactDatepicker = _interopRequireWildcard(require("react-datepicker"));

var _es = _interopRequireDefault(require("date-fns/locale/es"));

var _customHooks = require("../../../global-files/customHooks");

var _utils = require("../../../global-files/utils");

var _jsxRuntime = require("react/jsx-runtime");

(0, _reactDatepicker.registerLocale)("es", _es.default);

var RangeCalendar = function RangeCalendar(_ref) {
  var setParameterArray = _ref.setParameterArray,
      _ref$minDate = _ref.minDate,
      minDate = _ref$minDate === void 0 ? new Date() : _ref$minDate,
      currentDates = _ref.currentDates,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? "Elige las fechas" : _ref$label,
      _ref$calendarId = _ref.calendarId,
      calendarId = _ref$calendarId === void 0 ? "calendar-id" : _ref$calendarId;

  var _useState = (0, _react.useState)(new Date()),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      startDate = _useState2[0],
      setStartDate = _useState2[1];

  var _useState3 = (0, _react.useState)(new Date()),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      endDate = _useState4[0],
      setEndDate = _useState4[1];

  var _useCloseModal = (0, _customHooks.useCloseModal)(calendarId),
      _useCloseModal2 = (0, _slicedToArray2.default)(_useCloseModal, 2),
      showCalendar = _useCloseModal2[0],
      setShowCalendar = _useCloseModal2[1];

  (0, _react.useEffect)(function () {
    if (currentDates) {
      setStartDate(new Date(currentDates.start));
      setEndDate(new Date(currentDates.end));
    }
  }, [currentDates]);

  var onChange = function onChange(dates) {
    var _dates = (0, _slicedToArray2.default)(dates, 2),
        start = _dates[0],
        end = _dates[1];

    setStartDate(start);
    setEndDate(end);

    if (end) {
      setParameterArray && setParameterArray(function (current) {
        return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, current), {}, {
          estimatedStartDate: (0, _utils.getFormatedDate)(new Date(start), "-"),
          estimatedDate: (0, _utils.getFormatedDate)(new Date(end), "-")
        });
      });
    }
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Container, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "calendar-dropdown",
      onClick: function onClick(e) {
        e.stopPropagation();
        setShowCalendar(true);
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        children: label
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "arrow-item",
        children: "\u25C0"
      })]
    }), showCalendar && /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.CalendarContainer, {
      id: calendarId,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactDatepicker.default, {
        selected: startDate,
        onChange: onChange,
        startDate: startDate,
        endDate: endDate,
        renderCustomHeader: function renderCustomHeader(_ref2) {
          var monthDate = _ref2.monthDate,
              customHeaderCount = _ref2.customHeaderCount,
              decreaseMonth = _ref2.decreaseMonth,
              increaseMonth = _ref2.increaseMonth;
          return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
              "aria-label": "Previous Month",
              className: "react-datepicker__navigation react-datepicker__navigation--previous",
              style: customHeaderCount === 1 ? {
                visibility: "hidden"
              } : null,
              onClick: decreaseMonth,
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                className: "react-datepicker__navigation-icon react-datepicker__navigation-icon--previous",
                children: "<"
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              className: "react-datepicker__current-month",
              children: monthDate.toLocaleString("es-Es", {
                month: "long",
                year: "numeric"
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
              "aria-label": "Next Month",
              className: "react-datepicker__navigation react-datepicker__navigation--next",
              style: customHeaderCount === 0 ? {
                visibility: "hidden"
              } : null,
              onClick: increaseMonth,
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                className: "react-datepicker__navigation-icon react-datepicker__navigation-icon--next",
                children: ">"
              })
            })]
          });
        },
        monthsShown: 2,
        selectsRange: true,
        inline: true,
        minDate: minDate,
        locale: "es"
      })
    })]
  });
};

exports.RangeCalendar = RangeCalendar;